export type HitboxMode = 'OFF' | 'CURRENT' | 'ALL';

export interface HitboxBodyLike {
  label: string;
  vertices?: readonly { x: number; y: number }[];
  parts: readonly HitboxBodyLike[];
}

export interface HitboxTargets {
  animalIds: number[];
  includeSupport: boolean;
}

export function nextHitboxMode(mode: HitboxMode): HitboxMode {
  if (mode === 'OFF') return 'CURRENT';
  if (mode === 'CURRENT') return 'ALL';
  return 'OFF';
}

export function hitboxDebugEnabled(search: string): boolean {
  const params = new URLSearchParams(search);
  return params.get('debug') === '1' || params.get('e2e') === '1';
}

export function selectHitboxTargets(
  mode: HitboxMode,
  currentId: number | null,
  latestId: number | null,
  allAnimalIds: readonly number[],
): HitboxTargets {
  if (mode === 'ALL') return { animalIds: [...allAnimalIds], includeSupport: true };
  if (mode === 'CURRENT') {
    const targetId = currentId ?? latestId;
    return {
      animalIds: targetId !== null && allAnimalIds.includes(targetId) ? [targetId] : [],
      includeSupport: false,
    };
  }
  return { animalIds: [], includeSupport: false };
}

export function drawableHitboxParts(body: HitboxBodyLike): readonly HitboxBodyLike[] {
  return body.parts.length > 1 ? body.parts.slice(1) : [body];
}
